import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fort-awesome': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M489.2 287.9c2.6 0 4.6 2 4.5 4.6v219.5h-182.9v-96c0-72.6-109.7-72.6-109.7 0v96h-182.9v-219.5c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v32h36.6v-178.3c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v32h36.3v-32c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v32h36.6v-32c0-6 8-4.6 11.7-4.6v-111.7c-5.4-2.6-9.1-8.3-9.1-14.3 0-20.8 31.4-20.7 31.4 0 0 6-3.7 11.7-9.1 14.3v4.9c7.7-1.8 15.7-2.9 23.7-2.9 11.7 0 22.9 4.3 32.6 4.3 8.9 0 18.9-4.3 24-4.3 2.6 0 4.6 2 4.6 4.6v60c0 6.9-23.1 8-27.7 8-10.5 0-20.5-4.3-31.4-4.3-8.6 0-17.4 1.4-25.7 3.4v38c3.7 0 11.7-1.4 11.7 4.6v32h36.6v-32c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v32h36.6v-32c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v178.3h36.6v-32c0-2.6 2-4.6 4.6-4.6h27.4zM201.1 283.4v-64c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v64c0 2.6 2 4.6 4.6 4.6h27.4c2.6 0 4.6-2 4.6-4.6zM347.5 283.4v-64c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v64c0 2.6 2 4.6 4.6 4.6h27.4c2.6 0 4.6-2 4.6-4.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fort-awesome.js
// module id = 840
// module chunks = 0